import { FC, SVGAttributes } from 'react';

const CloseOutlined: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 2.5C18.0222 2.5 22.5 6.97676 22.5 12.5C22.5 18.0222 18.0222 22.5 12.5 22.5C6.97676 22.5 2.5 18.0222 2.5 12.5C2.5 6.97784 6.97784 2.5 12.5 2.5Z"
                stroke="currentColor"
                strokeWidth="1.62162"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.7404 9.24805L9.25391 15.7345"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.7404 15.7345L9.25391 9.24805"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CloseOutlined;
